<template>
	<div class="bodycont">
		<!-- 轮播图 -->
		<div class="swipercont swiper-container">
		     <div class="swiper-wrapper" >
		         <div class="swiper-slide" v-for="(item,index) in swipercont" @click="linkurl(item.link)">
		          <img :src="swiperurl+item.pic"  class="swiperimg"/>
		         </div>
		     </div>
		     <div class="swiper-pagination"></div>
		 </div> 
		 
		 
		 <!-- 通知活动等 -->
		 <div class="activecont Pub_width Pub_flexrow">
					
			  <div class="active_news">
				  <div class="currenttit Pub_flexrow">
					  <div class="currentcard" :class="currentindex==index?'currentcard_active':''" v-for="(item,index) in currenttit" @click="currentcli(item.scode,index)">{{item.name}}</div>
				  </div>
				  <newslist :listdata="activelistdata"></newslist>
			  </div>
			  <div class="activemesg_cont">
				  <div class="mesg1">
					  <div class="card_title">信息查询</div>
					  <div class="actcard_cont Pub_flexrow">
						  <img src="http://www.bjit.org.cn/template/default/images/home/xxcx.png" class="acticon"/>
						  <div class="hr"></div>
						  <div class="actmesglist Pub_flexcoloum">
							  <div class="actlist" @click="navtobook()">企业人力资源管理师证书查询</div>
						  </div>
					  </div>
				  </div>
				  
				  <div class="mesg1" style="margin-top: 20px;">
					  <div class="card_title">分支机构</div>
					  <div class="actcard_cont2 Pub_flexrow">
						  <div class="actcard2_menu Pub_flexcoloum" v-for="(item,index) in fenzhidata" @click="navtodetail(item.id,item.outlink)">
						  <img :src="swiperurl+item.ico" class="actfenlei_icon"/>
						  <div class="menutext">{{item.title}}</div>
						  </div>
					  </div>
				  </div>
			  </div>
		 </div>
		 
		 
		 <!-- 会员天地 -->
		 <div class="vipcont Pub_width" style="background: transparent;">
			  <div class="Pub_flexrow">
				  <div style="margin-right: 20px;background: white;">
					  <div class="card_title">会员天地</div>
					  <div class="vipnewslist vipblock">
						   <newslist :listdata="vipdata"></newslist>
					  </div>
				  </div>
				  <div style="background: white;">
					  <div class="card_title">在线视频</div>
					  <div class="vipnewslist vipblock">
						   <newslist :listdata="videodata"></newslist>
					  </div>
				  </div>
			  </div>
		 </div>
		 
		 <!-- 五个图片 -->
		 <div class="friend Pub_width">
		<!-- <div class="blocktitle Pub_flexrowcenter">
			 <div class="titlehr"></div>
			 <div>产品展示</div>
			 <div class="titlehr"></div>
		</div> -->
		 <div class="imgcont Pub_width Pub_flexrow">
			<div class="imgcontmenu Pub_flexcoloum_center" style="width: 20%;" @click="navtodetail(item.id,item.outlink)" v-for="(item,index) in xiangmuzhanshidata">
			<img  :src="swiperurl+item.ico" class="imgcontimg" />
			<div class="imgconttext">{{item.title}}</div>
		   </div>
		 </div>
		 </div>
		 
		 
		 
		 <!-- 项目对接 -->
		 <div class="Pub_flexrow Pub_width">
		 <div class="vipcont"  style="width: 900px;">
			  <div class="card_title">项目对接</div>
			  <div class="vipnewslist" style="height:200px">
				   <newslist :listdata="xiangmuduijiedata"></newslist>
			  </div>
		 </div>
		 <div class="wxcode Pub_flexcoloum">
					<div class="name">用微信扫一扫</div>
		    <img :src="swiperurl+companymesg.weixin" class="vipimg" />
					<div class="name">订阅微信公众号</div>
		  </div>
		 </div>
		 
		 
		 <!-- 合作伙伴 -->
		<!-- <div class="friend Pub_width">
		 <div class="blocktitle Pub_flexrowcenter">
			 <div class="titlehr"></div>
			 <div>合作伙伴</div>
			 <div class="titlehr"></div>
		 </div>
		 <div class="imgcont Pub_width Pub_flexrow" style="
														flex-wrap: wrap;
														padding-bottom: 30px;
													">
		 			<div class="imgcontmenu Pub_flexcoloum_center" style="width: 25%;margin-bottom: 10px;" @click="navtodetail(item.id)" v-for="(item,index) in companyfriend">
		 			<img  :src="swiperurl+item.ico" class="imgcontimg" style="width: 200px;"/>

					</div>
		 </div>
		 </div> -->
		 
	</div>
</template>

<script>
	import Swiper from 'swiper';
	import 'swiper/css/swiper.css';
	import newslist from '../components/list.vue'
	export default({
		data(){
			return{
				headmesg:["诚信","团结","专业","服务"],
				menulist:[
					{name:"首页"},{name:"政策服务"},{name:"党群工作"},{name:"党群工作"},
					{name:"团体标准"},{name:"行业研究"},{name:"关于协会"},{name:"联系我们"}
				],
				fenlei:[
					{name:"信息技术服务类",img:"http://www.bjit.org.cn/template/default/images/home/xxcx.png"},
					{name:"信息技术服务类",img:"http://www.bjit.org.cn/template/default/images/home/xxcx.png"},
					{name:"信息技术服务类",img:"http://www.bjit.org.cn/template/default/images/home/xxcx.png"}
				],
				currenttit:[
					{"name":"通知公告",scode:42},{"name":"活动信息",scode:43},{"name":"行业动态",scode:44}
				],
				currentindex:0,
				activelistdata:[],//通知活动列表
				swiperurl:"",
				swipercont:[],
				pagesite:[] ,//网站信息
				vipdata:[],//会员专区
				fenzhidata:[],
				xiangmuduijiedata:[],
				xiangmuzhanshidata:[],
				companymesg:[],
				vipcont_img:[],
				companyfriend:[],
				videodata:[]
			}
		},
		components:{
			newslist
		},
		methods:{
			// 初始化swiper
			swiperinit(){
			   var mySwiper = new Swiper (".swiper-container",{
				  autoplay:{
					  disableOnInteraction : false
				  },
					 loop:true,  //循环
					 observer:true,//修改swiper自己或子元素时，自动初始化swiper
				 　　 observeParents:true,//修改swiper的父元素时，自动初始化swiper
					 //使用分页器
					 paginationClickable :true,
				 　　 pagination: {
						 el: '.swiper-pagination',
					 },
					 
				 })
			},
			// 加载轮播图
			Loadswiper(){
				this.$Get("api.php/cms/slide/gid/1").then(res=>{
					this.swiperurl=this.$Pub_url
					this.swipercont=res.data.data
					this.$nextTick(()=>{
						this.swiperinit()
					})
				})  
				this.$Get("api.php/cms/slide/gid/2").then(res=>{
					this.vipcont_img=res.data.data
				})  
				this.$Get("api.php/cms/company").then(res=>{
					this.companymesg=res.data.data
				})
				this.$Get("api.php/cms/site").then(res=>{
					this.pagesite=res.data.data
				})
			
			},
			navtobook(){
				this.$router.push({name:"bookdetail"});
			},
			navtodetail(id,outlink){
				if(outlink){
				window.open(outlink)
				return;
				}
				this.$router.push({name:"detail",query:{id}})
			},
			// 轮播图跳转
			linkurl(url){
				window.open(url)
			},
			currentcli(scode,index){
				this.currentindex=index
				this.$Get('api.php/list/'+scode).then(res=>{
				  this.activelistdata=res.data.data
				})
			},
			Loadlist(scode){
				this.$Get('api.php/list/'+scode).then(res=>{
				  let data=res.data.data
				  if(scode==46){
					  this.vipdata=data
				  }
				  if(scode==45){
					 
					  this.fenzhidata=data
				  }
				  if(scode==47){
				    this.xiangmuduijiedata=data
				  }
				  if(scode==48){
					  this.xiangmuzhanshidata=data
				  }
				  if(scode==50){
					  this.companyfriend=data
				  }
				  if(scode==61){
					  this.videodata=data
				  }
				})
			}
			
		},
		created() {
			this.Loadswiper()
			this.currentcli(this.currenttit[0].scode,0);
			this.Loadlist(46)//会员
			this.Loadlist(45)//分支机构
			this.Loadlist(47)//项目对接
			this.Loadlist(48)//项目展示
			this.Loadlist(50)//项目展示
			this.Loadlist(61) //在先视频
		},
		mounted() {
			
			
		}
	})
</script>

<style scoped="scoped">
	
	/* 轮播图 */
	.swipercont{
	  width: 1100px;
	  margin: 0 auto;
	}
	.swiperimg{
		width: 100%;
		height: 485px;
	}
	
	
	/* 活动 */
	.activecont{
		margin-top: 20px;
	}
	.active_news{
		width: 838.08px;
		height: 325px;
		background: white;
		border-radius: 5px;
		padding: 10px;
		
	}
	.activemesg_cont{
		width: 302.63px;
		margin-left: 40px;
	}
	.card_title{
		border-bottom: 1px solid #e5e5e5;
		color: #024287;
		font-size: 16px;
		font-weight: bold;
		padding: 10px 25px;
	}
	.mesg1{
		background: white;
		border-radius: 5px;
		padding: 10px 0px 10px 0px;
	}
	.actcard_cont{
		width: 250px;
		margin: 0 auto;
		padding: 20px 0px 20px 0px;
	}
	.acticon{
		width: 57px;
		display: block;
		flex-shrink: 0;
		height: 53px;
	}
	.hr{
		display: block;
		width: 1px;
		height: 65px;
		background: #cecece;
		margin: 0 23px;
	}
	.actcard_cont2{
		justify-content: space-around;
		align-items: center;
	}
	.actcard2_menu{
		align-items: center;
		margin-top: 20px;
	}
	.actfenlei_icon{
		width: 45px;
		height: 45px;
	}
	.menutext{
		font-size: 14px;
		display: block;
		padding-top: 10px;
	}
	
	
	/* 切换标题 */
	.currenttit{
		white-space: nowrap;
		border-bottom-width: 2px;
		border-bottom-style: solid;
		border-bottom-color: #e5e5e5;
		margin-bottom: 10px;
		padding-left: 30px;
	}
	.currentcard{
		width: 100px;
		padding: 10px 0px;
		text-align: center;
		margin-right: 70px;
		border-bottom: 1px solid transparent;
		cursor: pointer;
	}
	.currentcard_active{
		border-bottom: 2px solid rgb(95,184,120);
	}
	
	.vipcont{
		background: white;
		border-radius: 5px;
		margin-top: 20px;
		
	}
	.vipnewslist{
		padding-left: 20px;
		margin-top: 10px;
		height: 300px;
		width: 700px;
		margin-right: 20px;
	}
	.vipblock{
		width: 500px;
	}
	.vipimg{
		width: 442px;
		height: 249px;
		margin-top: 20px;
		margin-left: 20px;
	}
	
	
	.imgcont{
		margin-top: 20px;
		background: white;
		padding: 20px 0px;
	}
	.imgcontimg{
		width: 210px;
		height: 150px;
		margin: 0 auto;
	}
	.wxcode{
		background: white;
		margin-top: 20px;
		margin-left: 45px;
		width: 250px;
		text-align: center;
	}
	.wxcode>img{
		width: 170px;
		height: 169px;
		margin: 0 auto;
		display: block;
	}
	.wxcode>.name{
		padding: 20px 0px;
	}
	
	.imgconttext{
		padding: 20px 0px 10px 0px;
		font-size: 14px;
		font-weight: 700;
		color: #666;
	}
	.actlist{
		cursor: pointer;
	}
	.friend{
		background: white;
		margin-top: 20px;
	}
	.blocktitle{
		font-weight: bold;
		text-align: center;
		font-size: 20px;
		padding: 20px 0px 5px 0px;
		color: #024287;
		justify-content: center;
	}
	.titlehr{
		width:500px;
		height: 2px;
		margin-left: 20px;
		margin-right: 20px;
		border-radius: 5px;
		background: #ECECEC;
	}
</style>



// WEBPACK FOOTER //
// src/view/index_page.vue